import { render, staticRenderFns } from "./AdminFormulasScreen.vue?vue&type=template&id=785793d3&scoped=true&"
import script from "./AdminFormulasScreen.vue?vue&type=script&lang=js&"
export * from "./AdminFormulasScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785793d3",
  null
  
)

export default component.exports